/*
  Help page (sections/om-help.liquid, om-help-topic.liquid, om-help-contact.liquid), 2026-11-04. Draft theme only.
  - The search box filters every question and answer on the page (all the words typed must appear), hides empty
    topics, opens the first few matches, and offers the chat when nothing matches.
  - The topics become quick links under the search.
  - A link to an answer (#shipping-how-long-will-it-take) opens it; "Copy link" copies that link for chat replies.
  - "Chat with us" opens the Crisp chat, or email when the chat isn't loaded.
  Runs again when a section is edited in the theme editor.
*/
(function () {
  if (window.omHelp) return;
  window.omHelp = true;

  var fold = function (text) { return (text || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/\s+/g, ' ').trim(); };
  var chat = function (email) {
    if (window.$crisp && window.$crisp.push) { window.$crisp.push(['do', 'chat:show']); window.$crisp.push(['do', 'chat:open']); }
    else if (email) location.href = 'mailto:' + email;
  };

  var init = function () {
    var hero = document.querySelector('.om-help');
    var topics = Array.from(document.querySelectorAll('.om-help-topic'));
    var items = Array.from(document.querySelectorAll('.om-help__q'));
    if (hero) document.documentElement.classList.add('om-help-on');

    // topics as quick links
    var chips = hero && hero.querySelector('.om-help__chips');
    if (chips) {
      chips.innerHTML = '';
      topics.forEach(function (t) {
        if (!t.dataset.title) return;
        var a = document.createElement('a');
        a.className = 'om-help__chip';
        a.href = '#' + t.id;
        a.textContent = t.dataset.title;
        chips.appendChild(a);
      });
    }

    // search
    var input = hero && hero.querySelector('.om-help__input');
    var status = hero && hero.querySelector('.om-help__status');
    items.forEach(function (d) { d._omText = fold(d.textContent.replace(d.querySelector('.om-help__copy') ? d.querySelector('.om-help__copy').textContent : '', '')); });
    var timer = null;
    var filter = function () {
      var q = fold(input.value);
      var words = q.split(' ').filter(Boolean);
      var found = 0;
      items.forEach(function (d) {
        var hit = !words.length || words.every(function (w) { return d._omText.indexOf(w) >= 0; });
        d.hidden = !hit;
        if (d.dataset.omAuto) { d.open = false; delete d.dataset.omAuto; }
        if (hit && words.length) {
          found += 1;
          if (found <= 3 && !d.open) { d.open = true; d.dataset.omAuto = '1'; }
        }
      });
      topics.forEach(function (t) { t.hidden = words.length > 0 && !t.querySelector('.om-help__q:not([hidden])'); });
      if (chips) chips.hidden = words.length > 0;
      if (!status) return;
      status.innerHTML = '';
      if (!words.length) return;
      var shown = input.value.trim();
      if (found) {
        var line = found === 1 && status.dataset.resultOne ? status.dataset.resultOne : status.dataset.results || '';
        status.textContent = line.replace(/\[n\]/g, found).replace(/\[q\]/g, shown);
      } else {
        status.appendChild(document.createTextNode((status.dataset.none || '').replace(/\[q\]/g, shown) + ' '));
        if (status.dataset.ask) {
          var ask = document.createElement('button');
          ask.type = 'button';
          ask.className = 'om-help__ask';
          ask.textContent = status.dataset.ask;
          ask.addEventListener('click', function () { chat(status.dataset.email); });
          status.appendChild(ask);
        }
      }
    };
    if (input && !input.dataset.omReady) {
      input.dataset.omReady = '1';
      input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(filter, 120); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { input.value = ''; filter(); } });
    }
    if (input && input.value) filter();

    // copy the link to an answer
    items.forEach(function (d) {
      var b = d.querySelector('.om-help__copy');
      if (!b || b.dataset.omReady) return;
      b.dataset.omReady = '1';
      var label = b.textContent;
      b.addEventListener('click', function () {
        var url = location.origin + location.pathname + '#' + d.id;
        var done = function () { b.textContent = b.dataset.copied || label; setTimeout(function () { b.textContent = label; }, 1800); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () { history.replaceState(null, '', '#' + d.id); done(); });
        else { history.replaceState(null, '', '#' + d.id); done(); }
      });
    });

    // chat buttons
    document.querySelectorAll('[data-om-chat]').forEach(function (b) {
      if (b.dataset.omReady) return;
      b.dataset.omReady = '1';
      b.addEventListener('click', function () { chat(b.dataset.email); });
    });
  };

  // open an answer named in the link
  var openHash = function () {
    var id = decodeURIComponent(location.hash.slice(1));
    var target = id && document.getElementById(id);
    if (target && target.classList.contains('om-help__q')) {
      target.hidden = false;
      target.open = true;
      setTimeout(function () { target.scrollIntoView({ block: 'start' }); }, 50);
    }
  };

  var start = function () { init(); openHash(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('hashchange', openHash);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', function (e) {
    var d = e.target && e.target.closest && e.target.closest('.om-help__q');
    if (d) d.open = true;
  });
})();
